import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

const links = [
  { to: '/', label: 'نظرة عامة', icon: '⌂', end: true },
  { to: '/products', label: 'المنتجات', icon: '▦' },
  { to: '/orders', label: 'الطلبات', icon: '⎘' },
  { to: '/customers', label: 'العملاء', icon: '☺' },
  { to: '/analytics', label: 'التحليلات', icon: '📊' },
  { to: '/settings', label: 'الإعدادات', icon: '⚙' },
];

export default function Sidebar() {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo}>
        <span className={styles.logoMark}>◆</span>
        <span className={styles.logoText}>لوحة التحكم</span>
      </div>

      <nav className={styles.nav}>
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }
          >
            <span className={styles.icon}>{link.icon}</span>
            <span>{link.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className={styles.footer}>
        <p>الإصدار 1.0.0</p>
      </div>
    </aside>
  );
}
